import { render, staticRenderFns } from "./DistributionSchedules.vue?vue&type=template&id=3cb93728&scoped=true"
import script from "./DistributionSchedules.vue?vue&type=script&lang=ts"
export * from "./DistributionSchedules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb93728",
  null
  
)

export default component.exports